import { FormInstance } from "antd"
import { useEffect, useState } from "react"

export const useNormalizeToIds = (form: FormInstance, fieldName: string, value: any[]) => {
  const [objects, setObjects] = useState<any[]>([])

  useEffect(() => {
    if (value && Array.isArray(value) && typeof value[0] === "object") {
      setObjects(value)

      form.setFieldsValue({
        [fieldName]: value.map((item: any) => item.id),
      })
    }
  }, [value, form, fieldName])

  return objects
}